"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var dayjs_1 = require("../utilities/dayjs");
var Batch_1 = require("./Batch");
var TransferStatus;
(function (TransferStatus) {
    TransferStatus["PENDING"] = "pending";
    TransferStatus["IN_PROGRESS"] = "inProgress";
    TransferStatus["COMPLETED"] = "completed";
    TransferStatus["CANCELLED"] = "cancelled";
})(TransferStatus = exports.TransferStatus || (exports.TransferStatus = {}));
var CreateOrUpdateTransfer = /** @class */ (function () {
    function CreateOrUpdateTransfer() {
        var _this = this;
        this.id = null;
        this.title = "Transfer " + dayjs_1.dayjs().format('MMM D YYYY');
        this.status = TransferStatus.PENDING;
        this.products = [];
        this.setFromLocation = function (fromLocation) {
            _this.fromLocationId = fromLocation;
        };
    }
    CreateOrUpdateTransfer.prototype.populate = function (json) {
        Object.assign(this, json);
        this.products = this.products.map(function (product) { return new TransferProduct(product); });
    };
    CreateOrUpdateTransfer.prototype.addProduct = function (product) {
        var entry = new TransferProduct();
        if (product) {
            // Only add product line if product does not already exist
            if (this.products.map(function (transferProduct) { return transferProduct.id; }).includes(product.id)) {
                return;
            }
            entry = new TransferProduct(product);
        }
        this.products = __spread(this.products, [entry]);
    };
    CreateOrUpdateTransfer.prototype.addProducts = function (products) {
        var _this = this;
        var entries = products.map(function (product) { return new TransferProduct(product); }).filter(function (product) { return !_this.products.map(function (p) { return p.id; }).includes(product.id); });
        this.products = __spread(this.products, entries);
    };
    CreateOrUpdateTransfer.prototype.removeProduct = function (index) {
        this.products.splice(index, 1);
    };
    __decorate([
        mobx_1.observable
    ], CreateOrUpdateTransfer.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrUpdateTransfer.prototype, "title", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrUpdateTransfer.prototype, "fromLocationId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrUpdateTransfer.prototype, "toLocationId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrUpdateTransfer.prototype, "startingUserId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrUpdateTransfer.prototype, "notes", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrUpdateTransfer.prototype, "status", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrUpdateTransfer.prototype, "completeDate", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrUpdateTransfer.prototype, "products", void 0);
    __decorate([
        mobx_1.action
    ], CreateOrUpdateTransfer.prototype, "populate", null);
    __decorate([
        mobx_1.action
    ], CreateOrUpdateTransfer.prototype, "addProduct", null);
    __decorate([
        mobx_1.action
    ], CreateOrUpdateTransfer.prototype, "addProducts", null);
    __decorate([
        mobx_1.action
    ], CreateOrUpdateTransfer.prototype, "removeProduct", null);
    __decorate([
        mobx_1.action
    ], CreateOrUpdateTransfer.prototype, "setFromLocation", void 0);
    return CreateOrUpdateTransfer;
}());
exports.CreateOrUpdateTransfer = CreateOrUpdateTransfer;
var TransferProduct = /** @class */ (function () {
    function TransferProduct(json) {
        var _this = this;
        this.id = null;
        this.name = null;
        // Only received from server, never updated, read only properly
        this.sku = null;
        // Only received from server, never updated, read only properly
        this.categoryName = null;
        // Only received from server, never updated, read only properly
        this.categoryId = null;
        this.unit = null;
        this.quantity = null;
        this.notes = null;
        this.indexOrder = null;
        this.costPerUnit = 0;
        this.total = 0;
        this.batches = [];
        // Used only in-browser
        this.batchOptions = [];
        this.addBatch = function (batch) {
            _this.batches.push(batch);
        };
        this.removeBatch = function (index) {
            _this.batches.splice(index, 1);
        };
        this.setBatchOptions = function (batchOptions) {
            _this.batchOptions = batchOptions;
        };
        if (json) {
            Object.assign(this, json);
            this.costPerUnit = Math.round(this.total / (this.quantity || 1));
            this.batches = json.batches ? json.batches.map(function (batch) { return new Batch_1.CreateTransferBatch(batch); }) : [];
        }
    }
    TransferProduct.prototype.setCostPerUnit = function (costPerUnit) {
        this.costPerUnit = costPerUnit;
        this.total = Math.round((this.quantity || 0) * costPerUnit);
    };
    TransferProduct.prototype.setQuantity = function (quantity) {
        this.quantity = quantity;
        this.total = Math.round((quantity || 0) * this.costPerUnit);
    };
    TransferProduct.prototype.setTotal = function (total) {
        this.total = total;
        if (total) {
            this.costPerUnit = Math.round(total / (this.quantity || 0));
        }
    };
    Object.defineProperty(TransferProduct.prototype, "sumBatchQuantity", {
        get: function () {
            return this.batches.reduce(function (prev, curr) { return prev + (curr.quantity || 0); }, 0);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "sku", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "categoryName", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "categoryId", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "unit", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "quantity", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "fromLocationInventory", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "toLocationInventory", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "notes", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "indexOrder", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "costPerUnit", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "total", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "isBatchTracked", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "batches", void 0);
    __decorate([
        mobx_1.observable
    ], TransferProduct.prototype, "batchOptions", void 0);
    __decorate([
        mobx_1.action
    ], TransferProduct.prototype, "setCostPerUnit", null);
    __decorate([
        mobx_1.action
    ], TransferProduct.prototype, "setQuantity", null);
    __decorate([
        mobx_1.action
    ], TransferProduct.prototype, "setTotal", null);
    __decorate([
        mobx_1.action
    ], TransferProduct.prototype, "addBatch", void 0);
    __decorate([
        mobx_1.action
    ], TransferProduct.prototype, "removeBatch", void 0);
    __decorate([
        mobx_1.action
    ], TransferProduct.prototype, "setBatchOptions", void 0);
    __decorate([
        mobx_1.computed
    ], TransferProduct.prototype, "sumBatchQuantity", null);
    return TransferProduct;
}());
exports.TransferProduct = TransferProduct;
//# sourceMappingURL=Transfer.js.map